/**
 * Centralized query-key factory for the Focused Lead View.
 *
 * Using a factory keeps keys consistent between `useQuery` callers,
 * `queryClient.setQueryData` writes (see `useNextLead`), and
 * `queryClient.invalidateQueries` calls (see `useSkipLead`,
 * `useSaveCallOutcome`).
 */
export const queryKeys = {
	focusedView: {
		all: ['focused-view'] as const,
		lead: (companyId: string | undefined) => ['focused-view', 'lead', companyId] as const,
		contacts: (companyId: string | undefined) => ['focused-view', 'contacts', companyId] as const,
		pacing: () => ['focused-view', 'pacing'] as const,
		keywordPins: () => ['focused-view', 'keyword-pins'] as const,
		outcomes: (companyId: string | undefined) => ['focused-view', 'outcomes', companyId] as const,
		skipReasons: (companyId: string | undefined) => ['focused-view', 'skip-reasons', companyId] as const,
		phoneCall: (phoneCallId: string | undefined) => ['focused-view', 'phone-call', phoneCallId] as const,
		leadCallHistory: (companyId: string | undefined) => ['focused-view', 'lead-call-history', companyId] as const,
		transcription: (transcriptionId: string | undefined) => ['focused-view', 'transcription', transcriptionId] as const,
		dealForm: (companyId: string | undefined, dealId?: string) =>
			['focused-view', 'deal-form', companyId, dealId ?? 'create'] as const,
		textConversation: (phoneNumberId: string | undefined, toE164: string | undefined) =>
			['focused-view', 'text-conversation', phoneNumberId, toE164] as const,
		textMessages: (conversationId: string | undefined) => ['focused-view', 'text-messages', conversationId] as const,
		unreadTextConversationsAll: ['focused-view', 'unread-text-conversations'] as const,
		unreadTextConversations: (phoneNumberId: string | undefined) =>
			['focused-view', 'unread-text-conversations', phoneNumberId] as const,
	},
} as const;
